export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8389.2a4f850d.jpg";